import { usePost } from '../../../sharedModules/hooks/useQuery';

const SEND_NOW_URL = '/collections/scheduled_emails/send_now';

interface SendNowParams {
  location: string;
  bill_code: string;
  tone: string;
  override_body?: string;
}

interface SendNowResponse {
  sent: boolean;
}

export interface SendNowErrorBody {
  error?: string;
  code?: string;
  manual_send_locked_until?: string;
}

export function useSendCollectionEmail() {
  const mutation = usePost<SendNowResponse>();

  const sendEmail = (params: SendNowParams) => mutation.mutateAsync({ url: SEND_NOW_URL, data: params });

  return { sendEmail, isLoading: mutation.isPending, isError: mutation.isError };
}
